import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.prueflauf-controlling';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufControllingEffects {

    PrueflaufControlling$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PRUEFLAUF_CONTROLLING),
        mergeMap((x: ac.GetPrueflaufControllingAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getPrueflaufControlling(x.prueflauf_id).pipe(
                map((result: any) => {
                    return new ac.GetPrueflaufControllingErfolgreichAction(result, x.prueflauf_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetPrueflaufControllingFehlerAction(error, x.prueflauf_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ControllingQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ControllingQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ControllingQueryService);
        }
        return this.service;
    }
}
